export const SIGNS = Object.freeze([
  { id: 'aries', name: 'Aries', short: 'Ari', glyph: '♈' },
  { id: 'taurus', name: 'Taurus', short: 'Tau', glyph: '♉' },
  { id: 'gemini', name: 'Gemini', short: 'Gem', glyph: '♊' },
  { id: 'cancer', name: 'Cancer', short: 'Can', glyph: '♋' },
  { id: 'leo', name: 'Leo', short: 'Leo', glyph: '♌' },
  { id: 'virgo', name: 'Virgo', short: 'Vir', glyph: '♍' },
  { id: 'libra', name: 'Libra', short: 'Lib', glyph: '♎' },
  { id: 'scorpio', name: 'Scorpio', short: 'Sco', glyph: '♏' },
  { id: 'sagittarius', name: 'Sagittarius', short: 'Sag', glyph: '♐' },
  { id: 'capricorn', name: 'Capricorn', short: 'Cap', glyph: '♑' },
  { id: 'aquarius', name: 'Aquarius', short: 'Aqu', glyph: '♒' },
  { id: 'pisces', name: 'Pisces', short: 'Pis', glyph: '♓' },
]);

export const PLANETS = Object.freeze({
  ascendant: { id: 'ascendant', name: 'Ascendant', short: 'As', className: 'planet-ascendant' },
  sun: { id: 'sun', name: 'Sun', short: 'Su', className: 'planet-sun' },
  moon: { id: 'moon', name: 'Moon', short: 'Mo', className: 'planet-moon' },
  mars: { id: 'mars', name: 'Mars', short: 'Ma', className: 'planet-mars' },
  mercury: { id: 'mercury', name: 'Mercury', short: 'Me', className: 'planet-mercury' },
  jupiter: { id: 'jupiter', name: 'Jupiter', short: 'Ju', className: 'planet-jupiter' },
  venus: { id: 'venus', name: 'Venus', short: 'Ve', className: 'planet-venus' },
  saturn: { id: 'saturn', name: 'Saturn', short: 'Sa', className: 'planet-saturn' },
  rahu: { id: 'rahu', name: 'Rahu', short: 'Ra', className: 'planet-rahu' },
  ketu: { id: 'ketu', name: 'Ketu', short: 'Ke', className: 'planet-ketu' },
  uranus: { id: 'uranus', name: 'Uranus', short: 'Ur', className: 'planet-uranus' },
  neptune: { id: 'neptune', name: 'Neptune', short: 'Ne', className: 'planet-neptune' },
  pluto: { id: 'pluto', name: 'Pluto', short: 'Pl', className: 'planet-pluto' },
});

export const PLANET_ORDER = Object.freeze([
  'ascendant',
  'sun',
  'moon',
  'mars',
  'mercury',
  'jupiter',
  'venus',
  'saturn',
  'rahu',
  'ketu',
  'uranus',
  'neptune',
  'pluto',
]);

export const NAKSHATRAS_27 = Object.freeze([
  'Ashwini',
  'Bharani',
  'Krittika',
  'Rohini',
  'Mrigashira',
  'Ardra',
  'Punarvasu',
  'Pushya',
  'Ashlesha',
  'Magha',
  'Purva Phalguni',
  'Uttara Phalguni',
  'Hasta',
  'Chitra',
  'Swati',
  'Vishakha',
  'Anuradha',
  'Jyeshtha',
  'Mula',
  'Purva Ashadha',
  'Uttara Ashadha',
  'Shravana',
  'Dhanishtha',
  'Shatabhisha',
  'Purva Bhadrapada',
  'Uttara Bhadrapada',
  'Revati',
]);

export const SBC_NAKSHATRAS_28 = Object.freeze([
  'Krittika',
  'Rohini',
  'Mrigashira',
  'Ardra',
  'Punarvasu',
  'Pushya',
  'Ashlesha',
  'Magha',
  'Purva Phalguni',
  'Uttara Phalguni',
  'Hasta',
  'Chitra',
  'Swati',
  'Vishakha',
  'Anuradha',
  'Jyeshtha',
  'Mula',
  'Purva Ashadha',
  'Uttara Ashadha',
  'Abhijit',
  'Shravana',
  'Dhanishtha',
  'Shatabhisha',
  'Purva Bhadrapada',
  'Uttara Bhadrapada',
  'Revati',
  'Ashwini',
  'Bharani',
]);

// A 9 × 9 Sarvatobhadra grid has 32 perimeter cells. Excluding the four
// corners leaves exactly 28 cells, one for each nakshatra including Abhijit.
export const SBC_PERIMETER = Object.freeze([
  ...Array.from({ length: 7 }, (_, index) => ({ row: 0, col: index + 1 })),
  ...Array.from({ length: 7 }, (_, index) => ({ row: index + 1, col: 8 })),
  ...Array.from({ length: 7 }, (_, index) => ({ row: 8, col: 7 - index })),
  ...Array.from({ length: 7 }, (_, index) => ({ row: 7 - index, col: 0 })),
]);

export const KOTA_NAKSHATRAS_28 = Object.freeze([
  'Chitra',
  'Swati',
  'Vishakha',
  'Anuradha',
  'Jyeshtha',
  'Mula',
  'Purva Ashadha',
  'Uttara Ashadha',
  'Abhijit',
  'Shravana',
  'Dhanishtha',
  'Shatabhisha',
  'Purva Bhadrapada',
  'Uttara Bhadrapada',
  'Revati',
  'Ashwini',
  'Bharani',
  'Krittika',
  'Rohini',
  'Mrigashira',
  'Ardra',
  'Punarvasu',
  'Pushya',
  'Ashlesha',
  'Magha',
  'Purva Phalguni',
  'Uttara Phalguni',
  'Hasta',
]);

export const KOTA_LAYER_BY_NUMBER = Object.freeze({
  1: 'bahya', 7: 'bahya', 8: 'bahya', 14: 'bahya', 15: 'bahya', 21: 'bahya', 22: 'bahya', 28: 'bahya',
  2: 'prakaara', 6: 'prakaara', 9: 'prakaara', 13: 'prakaara', 16: 'prakaara', 20: 'prakaara', 23: 'prakaara', 27: 'prakaara',
  3: 'madhya', 5: 'madhya', 10: 'madhya', 12: 'madhya', 17: 'madhya', 19: 'madhya', 24: 'madhya', 26: 'madhya',
  4: 'stambha', 11: 'stambha', 18: 'stambha', 25: 'stambha',
});

// Coordinates mirror the reference layout while remaining an original SVG.
export const KOTA_POSITIONS = Object.freeze([
  { number: 1, x: 72, y: 62 },
  { number: 2, x: 150, y: 150 },
  { number: 3, x: 250, y: 250 },
  { number: 4, x: 400, y: 392 },
  { number: 5, x: 400, y: 250 },
  { number: 6, x: 400, y: 150 },
  { number: 7, x: 400, y: 62 },
  { number: 8, x: 728, y: 62 },
  { number: 9, x: 650, y: 150 },
  { number: 10, x: 550, y: 250 },
  { number: 11, x: 500, y: 392 },
  { number: 12, x: 600, y: 392 },
  { number: 13, x: 700, y: 392 },
  { number: 14, x: 776, y: 392 },
  { number: 15, x: 728, y: 730 },
  { number: 16, x: 650, y: 640 },
  { number: 17, x: 550, y: 540 },
  { number: 18, x: 400, y: 500 },
  { number: 19, x: 400, y: 540 },
  { number: 20, x: 400, y: 640 },
  { number: 21, x: 400, y: 730 },
  { number: 22, x: 72, y: 730 },
  { number: 23, x: 150, y: 640 },
  { number: 24, x: 250, y: 540 },
  { number: 25, x: 300, y: 392 },
  { number: 26, x: 200, y: 392 },
  { number: 27, x: 100, y: 392 },
  { number: 28, x: 24, y: 392 },
]);

export const KAKSHA_LORDS = Object.freeze([
  'Saturn',
  'Jupiter',
  'Mars',
  'Sun',
  'Venus',
  'Mercury',
  'Moon',
  'Ascendant',
]);

export const MAJOR_ASPECTS = Object.freeze([
  { id: 'conjunction', angle: 0, orb: 7, label: 'Conjunction' },
  { id: 'sextile', angle: 60, orb: 4, label: 'Sextile' },
  { id: 'square', angle: 90, orb: 5, label: 'Square' },
  { id: 'trine', angle: 120, orb: 5, label: 'Trine' },
  { id: 'opposition', angle: 180, orb: 7, label: 'Opposition' },
]);

export const DEFAULT_STEP_IDS = Object.freeze(['day', 'week', 'month', 'year']);

export const STEP_DEFINITIONS = Object.freeze([
  { id: 'day', label: 'Day', unit: 'days', amount: 1, expert: false },
  { id: 'week', label: 'Week', unit: 'days', amount: 7, expert: false },
  { id: 'month', label: 'Month', unit: 'months', amount: 1, expert: false },
  { id: 'year', label: 'Year', unit: 'years', amount: 1, expert: false },
  { id: 'tenYears', label: '10 Years', unit: 'years', amount: 10, expert: true },
  { id: 'hour', label: 'Hour', unit: 'hours', amount: 1, expert: true },
  { id: 'tenMinutes', label: '10 Minutes', unit: 'minutes', amount: 10, expert: true },
  { id: 'minute', label: 'Minute', unit: 'minutes', amount: 1, expert: true },
  { id: 'tenSeconds', label: '10 Seconds', unit: 'seconds', amount: 10, expert: true },
  { id: 'second', label: 'Second', unit: 'seconds', amount: 1, expert: true },
]);
